import { useTranslation } from 'react-i18next';

import styles from './LanguageDisplay.module.scss';

const dataTestIds = {
  option: (index?: number) => `settings-select-language-${index}`,
  placeholder: (_index?: number) => 'settings-select-language-field',
  singleValue: (_index?: number) => 'settings-select-language-field',
};

export function LanguageDisplay(props: {
  language?: { name: string; id: string; shortCode?: string };
  showShortLanguageCode?: boolean;
  customStyles?: {
    languageName?: React.CSSProperties;
    singleValue?: React.CSSProperties;
    icon?: React.CSSProperties;
    option?: React.CSSProperties;
  };
  isMenuOpen?: boolean;
  type?: 'option' | 'placeholder' | 'singleValue';
  index?: number;
}) {
  const { t } = useTranslation();

  const getDisplayText = () => {
    if (!props?.language?.name) {
      return t('profile.selectLanguage');
    }
    if (props.showShortLanguageCode) {
      return props.language.shortCode;
    }

    return props.language.name;
  };

  const getDataTestId = () => {
    if (props.type && dataTestIds[props.type]) {
      return dataTestIds[props.type](props.index);
    }
  };

  return (
    <div className={styles.displayWrapper} data-testid={getDataTestId()} style={props.customStyles?.singleValue}>
      <span
        className={styles.languageName}
        style={{
          ...props.customStyles?.languageName,
          ...(props.isMenuOpen ? props.customStyles?.option : {}),
        }}
      >
        {getDisplayText()}
      </span>
    </div>
  );
}
